export default __webpack_public_path__ + "static/media/GIF-about-society.d69e553b.png";